import React from 'react';
import Button from 'src/components/form/Button';

interface CsvUploadButtonsProps {
  isUploadSuccessful: boolean;
  hasFile: boolean;
  isDisabled: boolean;
  isUploading?: boolean;
  onCancel: () => void;
  onUpload: () => void;
  onSelectFile: () => void;
  onUploadAnother: () => void;
  onDone: () => void;
}

export const CsvUploadButtons: React.FC<CsvUploadButtonsProps> = ({
  isUploadSuccessful,
  hasFile,
  isDisabled,
  isUploading,
  onCancel,
  onUpload,
  onSelectFile,
  onUploadAnother,
  onDone,
}) => {
  if (isUploadSuccessful) {
    return (
      <div className="buttons">
        <Button secondary onClick={onUploadAnother}>
          UPLOAD ANOTHER FILE
        </Button>
        <Button primary onClick={onDone}>
          DONE
        </Button>
      </div>
    );
  }

  return (
    <div className="buttons">
      <Button secondary onClick={onCancel}>
        CANCEL
      </Button>
      <Button primary onClick={hasFile ? onUpload : onSelectFile} disabled={hasFile && isDisabled} loading={hasFile && isUploading}>
        {hasFile ? 'UPLOAD' : 'SELECT FILE'}
      </Button>
    </div>
  );
};
